// extracted by mini-css-extract-plugin
module.exports = {"content":"tyE1W","active":"xM5xx","price":"fcuTU","subtitle":"J3HuX","category":"_1IJ_L","button":"_3ipL8","description":"_2epik"};